import React from 'react';
import classes from './DividerIcon.scss';

import dividerImage from '../../../assets/images/engine-divider.svg';

const dividerIcon = () => (
    <div className={`${classes.Divider} u-transitionAll300Ease u-flex align-items-center justify-content-center`} style={{border: 'none'}}>
        <img src={dividerImage} alt='Exchange'/>
    </div>
); 

export default dividerIcon;


// WEBPACK FOOTER //
// ./src/components/BookingEngine/DividerIcon/DividerIcon.js